import * as actions from './actions';

export type SidebarState =
  | 'Hidden'
  | 'PopupOpen'
  | 'PopupClosed'
  | 'Collapsed'
  | 'Uncollapsed';

const state: { current: SidebarState } = { current: 'Hidden' };

export { state, actions };
